export const ERROR_DATABASE_INITIALIZATION = "An unexpected error occurred while initializing the databases.";

export const ERROR_DATABASE_SYNC = "An unexpected error occurred while syncing the databases.";

export const ERROR_AUTH = "An unexpected error occurred while authenticating the user.";

export const ERROR = "An unexpected error occurred.";

export const GO_TO_LIBRARY = "Go to apps library";

export const LOGOUT = "Logout";

export const SEARCH = "Search";